import Toastify from 'toastify-js'

const copyBtn = document.querySelector('.copyBtn')

if (copyBtn) {
	const copyText = document.querySelector('.copyTxt').textContent
	copyBtn.addEventListener('click', () => {
		navigator.clipboard.writeText(copyText).then(() => {
			Toastify({
				text: 'Copied to clipboard',
				close: true,

				duration: 3000
			}).showToast()
		})
	})
}
